import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Login, Register } from "@/pages/Auth";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import { FirstAccess } from "@/pages/FirstAccess";
import { Home } from "@/pages/Home";
import { Categories, CategoryDetail } from "@/pages/Categories";
import { Packs, PackDetail } from "@/pages/Packs";
import { Favorites } from "@/pages/Favorites";
import { Novidades, Suggestions } from "@/pages/Novidades";
import { Account } from "@/pages/Account";
import { Admin } from "@/pages/Admin";

function FullLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="animate-spin text-[#C58B90]" size={36} />
    </div>
  );
}

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/cadastro" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/esqueci-senha" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
          <Route path="/primeiro-acesso" element={<PublicOnly><FirstAccess /></PublicOnly>} />
          <Route path="/redefinir-senha" element={<ResetPassword />} />
          <Route path="/" element={<Protected><Home /></Protected>} />
          <Route path="/categorias" element={<Protected><Categories /></Protected>} />
          <Route path="/categorias/:id" element={<Protected><CategoryDetail /></Protected>} />
          <Route path="/packs" element={<Protected><Packs /></Protected>} />
          <Route path="/packs/:id" element={<Protected><PackDetail /></Protected>} />
          <Route path="/favoritos" element={<Protected><Favorites /></Protected>} />
          <Route path="/novidades" element={<Protected><Novidades /></Protected>} />
          <Route path="/sugestoes" element={<Protected><Suggestions /></Protected>} />
          <Route path="/conta" element={<Protected><Account /></Protected>} />
          <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
